import { combineReducers } from "redux";
import usersReducer from "./usersReducer";
import documentReducer from "./documentReducer";
import toolboxReducer from "./toolboxReducer";
import vehicleReducer from "./vehicleReducer";
import awpReducer from "./awpReducer";
import forkliftReducer from "./forkliftReducer";
import harnessReducer from "./harnessReducer";
import craneReducer from "./craneReducer";
import scaffoldReducer from "./scaffoldReducer";
import swagerReducer from "./swagerReducer";
import testbedReducer from "./testbedReducer";
import inventoryReducer from "./inventoryReducer";
import incidentReducer from "./incidentReducer";
import equipmentReducer from "./equipmentReducer";
import fallprotectionReducer from "./fallprotectionReducer";


const rootReducer = combineReducers({
  users: usersReducer,
  documents: documentReducer,
  toolbox: toolboxReducer,
  vehicle: vehicleReducer,
  awp: awpReducer,
  forklift: forkliftReducer,
  equipment: equipmentReducer,
  harness: harnessReducer,
  inventory: inventoryReducer,
  crane: craneReducer,
  swager: swagerReducer,
  testbed: testbedReducer,
  scaffold: scaffoldReducer,
  incident: incidentReducer,
  fallprotection: fallprotectionReducer,
  
});

export default rootReducer;
